import React from 'react';
import Header from '@sharedComponent/header/header';
import LottieComponent from '@sharedComponent/lottie-component';
import LottieFile from '@assets/lottiefiles';
import { Col, Row, Table, DatePicker, Input, Button } from 'antd';
import GifLoader from '@sharedComponent/gif-loader';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

// const { RangePicker } = DatePicker;
// const dateFormat = 'MM/DD/YYYY';
const CreateCommissionReportAffiliatePresentational = ({ state, columns, dataSource, addComments, comments, removeComment, valueChange }) => {
	const footer = (value) => {
		let total = 0;
		value.map((e) => {
			total = total + e.commissionAmount;
		});
		return (
			<Row className="tb_foolter_area">
				<Col xl={1}></Col>
				<Col xl={20} className="total">
					Total
				</Col>
				<Col xl={3} className="total_amt">
					{' '}
					$ {total}
				</Col>
			</Row>
		);
	};

	return (
		<>
			{state.loading ? (
				<Col style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
					{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
					<GifLoader />
				</Col>
			) : (
				<>
					<Header title="Dashboard / Commission Summary/ Bri Manager" />
					<Col className="create-commision-report-affiliate-container">
						<Row>
							<Col xl={12} lg={12} md={12} sm={24} xs={24} className="create-commision-report-affiliate-card-header">
								Bri Manager Commission Summery : 08/02/2020
							</Col>
							<Col xl={12} lg={12} md={12} sm={24} xs={24} className="create-commision-report-affiliate-card-header-right"></Col>
						</Row>
						<Col style={{ marginTop: 25, border: '1.2px solid #DDE2EA' }}>
							<Table
								pagination={{
									position: ['bottomCenter', 'bottomCenter'],
									defaultPageSize: 5,
									showSizeChanger: true,
									pageSizeOptions: ['5', '10'],
								}}
								dataSource={dataSource}
								columns={columns}
								footer={footer}
								className="create-commission-summary-report-table"
							/>
						</Col>

						<Row style={{ marginTop: 20 }}>
							<Col className="notes">NOTES:</Col>
							<Col className="cards_content" style={{ marginTop: 20 }}>
								<Col>Hi Bri,</Col>
								<Col>
									Please see your July 2020 Commission report review and approval is due by 08/15/2020 failure to provoide
									modificationsprior to Midnight 08/02./2020 will be an implied approval
								</Col>
								Thank you
							</Col>
						</Row>
						<Row style={{ marginTop: 20, flexDirection: 'row' }} align="middle">
							<Col className="notes">MY NOTES:</Col>
							<Col className="notes">
								<Button type="primary" style={{ marginLeft: 10, height: 'inherit' }} icon={<PlusOutlined />} onClick={addComments}>
									Add Notes
								</Button>
							</Col>
							{comments.length !== 0 && (
								<Col className="cards_content" xl={24} style={{ marginTop: 20 }}>
									{comments.map((comment, i) => (
										<Row key={i} style={{ marginBottom: 5 }}>
											<Col xl={22}>
												<Input onChange={(e) => valueChange(comment.key, e.target.value)} />
											</Col>
											<Col xl={2} className="flc">
												<Button
													type="primary"
													style={{ height: 'inherit', padding: 'inherit' }}
													onClick={() => removeComment(comment.key)}
													icon={<DeleteOutlined />}
												/>
											</Col>
										</Row>
									))}
								</Col>
							)}
						</Row>
					</Col>
				</>
			)}
		</>
	);
};

export default CreateCommissionReportAffiliatePresentational;
